import React from 'react';
import '../styles/components/LifestyleSection.css';

const LifestyleSection = ({ formData, setFormData }) => {
  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      lifestyle: {
        ...prev.lifestyle,
        [field]: value
      }
    }));
  };

  return (
    <div className="lifestyle-section">
      <h3 className="tsumugi-card-title">🌱 生活習慣（任意）</h3>
      <p className="lifestyle-section__hint">
        日々の食事・睡眠・運動習慣について教えてください。これらの情報を基に、実践しやすい改善提案をいたします。
      </p>

      {/* 食習慣 */}
      <div className="lifestyle-section__subsection">
        <h4 className="lifestyle-section__subsection-title">
          食習慣
        </h4>

        <div className="lifestyle-section__grid">
          <div>
            <label className="profile-edit-label">
              主食の傾向
            </label>
            <select
              className="profile-edit-select"
              value={formData.lifestyle?.mainFood || ''}
              onChange={(e) => handleInputChange('mainFood', e.target.value)}
            >
              <option value="">選択してください</option>
              <option value="rice_heavy">米・パン中心（炭水化物多め）</option>
              <option value="balanced">バランス良く摂取</option>
              <option value="protein_heavy">タンパク質・野菜中心</option>
              <option value="irregular">不規則・偏りがち</option>
            </select>
          </div>

          <div>
            <label className="profile-edit-label">
              甘いものの摂取頻度
            </label>
            <select
              className="profile-edit-select"
              value={formData.lifestyle?.sweetCraving || ''}
              onChange={(e) => handleInputChange('sweetCraving', e.target.value)}
            >
              <option value="">選択してください</option>
              <option value="none">ほとんど食べない</option>
              <option value="sometimes">たまに食べる</option>
              <option value="daily">毎日食べる</option>
              <option value="frequent">頻繁に欲しくなる</option>
            </select>
          </div>

          <div>
            <label className="profile-edit-label">
              食事の規則性
            </label>
            <select
              className="profile-edit-select"
              value={formData.lifestyle?.mealTiming || ''}
              onChange={(e) => handleInputChange('mealTiming', e.target.value)}
            >
              <option value="">選択してください</option>
              <option value="regular">規則正しく3食</option>
              <option value="skip_breakfast">朝食を抜くことが多い</option>
              <option value="late_dinner">夕食が遅い</option>
              <option value="irregular">食事時間が不規則</option>
            </select>
          </div>

          <div>
            <label className="profile-edit-label">
              水分摂取量（1日）
            </label>
            <select
              className="profile-edit-select"
              value={formData.lifestyle?.waterIntake || ''}
              onChange={(e) => handleInputChange('waterIntake', e.target.value)}
            >
              <option value="">選択してください</option>
              <option value="low">1L未満</option>
              <option value="moderate">1〜1.5L</option>
              <option value="adequate">1.5〜2L</option>
              <option value="high">2L以上</option>
            </select>
          </div>
        </div>
      </div>

      {/* 睡眠習慣 */}
      <div className="lifestyle-section__subsection">
        <h4 className="lifestyle-section__subsection-title">
          睡眠習慣
        </h4>

        <div className="lifestyle-section__grid">
          <div>
            <label className="profile-edit-label">
              平均睡眠時間
            </label>
            <select
              className="profile-edit-select"
              value={formData.lifestyle?.sleepDuration || ''}
              onChange={(e) => handleInputChange('sleepDuration', e.target.value)}
            >
              <option value="">選択してください</option>
              <option value="short">5時間未満</option>
              <option value="insufficient">5〜6時間</option>
              <option value="adequate">7〜8時間</option>
              <option value="long">9時間以上</option>
            </select>
          </div>

          <div>
            <label className="profile-edit-label">
              睡眠の質
            </label>
            <select
              className="profile-edit-select"
              value={formData.lifestyle?.sleepQuality || ''}
              onChange={(e) => handleInputChange('sleepQuality', e.target.value)}
            >
              <option value="">選択してください</option>
              <option value="poor">眠りが浅い・途中で起きる</option>
              <option value="fair">まあまあ眠れる</option>
              <option value="good">ぐっすり眠れる</option>
              <option value="varies">日によって違う</option>
            </select>
          </div>
        </div>
      </div>

      {/* 運動習慣 */}
      <div className="lifestyle-section__subsection">
        <h4 className="lifestyle-section__subsection-title">
          運動・活動習慣
        </h4>

        <div className="lifestyle-section__grid">
          <div>
            <label className="profile-edit-label">
              運動頻度
            </label>
            <select
              className="profile-edit-select"
              value={formData.lifestyle?.exerciseFrequency || ''}
              onChange={(e) => handleInputChange('exerciseFrequency', e.target.value)}
            >
              <option value="">選択してください</option>
              <option value="none">ほとんど運動しない</option>
              <option value="light">軽い運動（週1〜2回）</option>
              <option value="moderate">適度な運動（週3〜4回）</option>
              <option value="heavy">頻繁に運動（週5回以上）</option>
            </select>
          </div>

          <div>
            <label className="profile-edit-label">
              日常の活動量
            </label>
            <select
              className="profile-edit-select"
              value={formData.lifestyle?.dailyActivity || ''}
              onChange={(e) => handleInputChange('dailyActivity', e.target.value)}
            >
              <option value="">選択してください</option>
              <option value="sedentary">座り仕事中心・移動が少ない</option>
              <option value="light">軽い活動（立ち仕事・家事など）</option>
              <option value="moderate">中程度の活動（歩く機会が多い）</option>
              <option value="active">活発（体を動かす仕事・趣味）</option>
            </select>
          </div>
        </div>
      </div>

      {/* ストレス */}
      <div>
        <h4 className="lifestyle-section__subsection-title">
          ストレス・環境
        </h4>

        <div className="lifestyle-section__grid">
          <div>
            <label className="profile-edit-label">
              ストレスレベル
            </label>
            <select
              className="profile-edit-select"
              value={formData.lifestyle?.stressLevel || ''}
              onChange={(e) => handleInputChange('stressLevel', e.target.value)}
            >
              <option value="">選択してください</option>
              <option value="low">あまりストレスを感じない</option>
              <option value="moderate">適度なストレス</option>
              <option value="high">強いストレスを感じる</option>
              <option value="overwhelming">非常に強いストレス</option>
            </select>
          </div>

          <div>
            <label className="profile-edit-label">
              リラックス方法
            </label>
            <select
              className="profile-edit-select"
              value={formData.lifestyle?.relaxationMethod || ''}
              onChange={(e) => handleInputChange('relaxationMethod', e.target.value)}
            >
              <option value="">選択してください</option>
              <option value="none">特にない</option>
              <option value="hobby">趣味・読書・音楽など</option>
              <option value="exercise">運動・散歩</option>
              <option value="meditation">瞑想・ヨガ・入浴</option>
              <option value="social">人との会話・交流</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LifestyleSection;
